import SkillGapListContainer from '@src/components/skillbasedrecommendations/SkillBasedRecommendationsListContainer';
import React from 'react';

const AdminSkillsGapPage = () => <SkillGapListContainer/>;

export default AdminSkillsGapPage;
